import { useState } from "react";
import { InvoicePositionBase } from "../../types/invoice";
import { colors, spacing, borderRadius, typography, styles, createButtonStyle } from "../../styles/theme";

type Props = {
  onAdd: (pos: InvoicePositionBase) => void;
  onCancel: () => void;
};

export default function BaseForm({ onAdd, onCancel }: Props) {
  const [amount, setAmount] = useState<number>(0);
  const [vat, setVat] = useState<number>(23);
  const [gtuCode, setGtuCode] = useState<string>("GTU_12");
  const [description, setDescription] = useState("");
  const [name, setName] = useState("Podstawa");

  const disabled = !(amount > 0);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (disabled) return;
        onAdd({
          type: "base",
          name,
          amount_netto: amount,
          vat,
          description,
          gtu_code: gtuCode || null,
        });
      }}
      style={{
        padding: spacing.lg,
        background: colors.backgroundAlt,
        borderRadius: borderRadius.md,
        border: `1px solid ${colors.border}`,
      }}
    >
      <div style={{
        marginBottom: spacing.md,
        padding: spacing.md,
        background: colors.infoLight,
        borderLeft: `3px solid ${colors.info}`,
        borderRadius: borderRadius.sm,
      }}>
        <strong style={{ fontSize: typography.fontSize.base }}>Pozycja: Podstawa</strong>
        <div style={{ fontSize: typography.fontSize.sm, color: colors.textSecondary, marginTop: spacing.xs }}>
          Stała kwota netto do dodania na fakturze
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: spacing.md, marginBottom: spacing.md }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
          <span style={{ fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.medium }}>
            Nazwa pozycji:
          </span>
          <input
            value={name}
            onChange={e => setName(e.target.value)}
            style={styles.input}
          />
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
          <span style={{ fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.medium }}>
            Kwota netto (PLN):
          </span>
          <input
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
            style={styles.input}
          />
        </label>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: spacing.md, marginBottom: spacing.lg }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
          <span style={{ fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.medium }}>
            VAT (%):
          </span>
          <select value={vat} onChange={(e) => setVat(Number(e.target.value))} style={styles.select}>
            <option value={23}>23%</option>
            <option value={8}>8%</option>
            <option value={0}>0%</option>
            <option value={5}>5%</option>
          </select>
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
          <span style={{ fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.medium }}>
            GTU:
          </span>
          <select value={gtuCode} onChange={(e) => setGtuCode(e.target.value)} style={styles.select}>
            <option value="GTU_12">GTU_12</option>
            <option value="">Brak</option>
          </select>
        </label>

        <label style={{ display: 'flex', flexDirection: 'column', gap: spacing.xs }}>
          <span style={{ fontSize: typography.fontSize.sm, fontWeight: typography.fontWeight.medium }}>
            Opis (opcjonalny):
          </span>
          <input
            placeholder="Tylko wewnętrznie"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={styles.input}
          />
        </label>
      </div>

      <div style={{ display: 'flex', gap: spacing.md }}>
        <button type="submit" disabled={disabled} style={createButtonStyle('primary', disabled)}>
          ✅ Dodaj pozycję
        </button>
        <button type="button" onClick={onCancel} style={createButtonStyle('secondary')}>
          ❌ Anuluj
        </button>
      </div>
    </form>
  );
}
